module.exports = __webpack_public_path__ + "static/media/k5-promo.b6deef4a.png";